import { Component, Input } from '@angular/core';
import { CommonModule } from '@angular/common';
import { InpageSearchComponent } from '../inpage-search/inpage-search.component';
import { RadioGroupComponent } from '../../atoms/radio-group/radio-group.component';
import { RadioComponent } from '../../atoms/radio/radio.component';
import { CardComponent } from '../../molecules/card/card.component';
import { SearchGroup } from '../../../shared/interfaces/search-group.interface';
import { ButtonType } from '../../../shared/enums/button-type.enums';
import { RadioType } from '../../../shared/enums/radio-type.enums';

import { ContactCard } from '../../../shared/interfaces/card.interface';
import LinkType from '../../../shared/enums/link-type.enums';

import { Colors } from '../../../shared/enums/shared.enums';
import { GlobalSearchType } from '../../../shared/enums/global-search-type.enums';
import { CapitalizePipe } from '../../capitalize.pipe';

@Component({
  selector: 'hdi-global-search',
  standalone: true,
  imports: [
    InpageSearchComponent,
    RadioGroupComponent,
    RadioComponent,
    CardComponent,
    CommonModule,
    CapitalizePipe,
  ],
  templateUrl: './global-search.component.html',
  styleUrls: ['./global-search.component.scss'],
})
export class GlobalSearchComponent {
  @Input() type: GlobalSearchType = GlobalSearchType.PAGE;
  @Input() globalHeadline: string = 'Ihr Suchergebnis';
  @Input() searchPlaceholder: string = 'Suche';
  @Input() searchGroup?: SearchGroup[];
  @Input() labelCTA: string = 'Suchen';

  public founded: number = 0;

  public readonly buttonType = ButtonType;
  public readonly RadioType = RadioType;
  public readonly GlobalSearchType = GlobalSearchType;

  cards: ContactCard[] = [
    {
      icon: 'phone',
      title: 'Technische Hotline',
      textLink: '+49 221 144 2000',
      link: 'tel:+492211442000',
      linkType: LinkType.INLINE,
      date: '(Mo - Fr, 8:00 - 17:00 Uhr)',
      disabled: false,
      iconColor: Colors.BLACK,
      linkTarget: '_self',
    },
    {
      icon: 'envelope',
      title: 'Technische Hotline',
      link: 'mailto:vertriebshotline@hdi.de',
      textLink: 'E-Mail schreiben',
      subtitle: 'vertriebshotline@hdi.de',
      disabled: false,
      iconColor: Colors.BLACK,
      linkType: LinkType.PRIMARY_ARROW,
      linkTarget: '_self',
    },
  ];
}
